import React, { createContext, useContext, useState, useEffect } from 'react';
import config from "../config";
import Cookies from 'js-cookie';
import axios from 'axios';

const AuthContext = createContext(null);
axios.defaults.baseURL = config.BASE_URL;

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return Cookies.get('isAuthenticated') === 'true';
  });

  
  const [activeModule, setActiveModule] = useState(sessionStorage.getItem('actMod')); // Track the active module


  const [username, setUsername] = useState('');
  const [userProfile, setUserProfile] = useState('');

  const [TripIDState, setTripIDState] = useState('');
  const [reviseBillState, setReviseBillState] = useState('');


  const [isLoading, setIsLoading] = useState(true);

  const [moduleChange, setModuleChange] = useState('');
  const [searchValue, setSearchValue] = useState();





  const setAuth = (value, username, profile) => {

    setIsAuthenticated(value);
    setUsername(username);
    setUserProfile(profile)
    if (value) {
      Cookies.set('isAuthenticated', 'true', {
        secure: true,
        sameSite: 'Strict',
        expires: 1
      })// 1 days;
      console.log(Cookies.get('isAuthenticated'));
    }
    else {
      Cookies.remove('isAuthenticated');
    }
  };

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await axios.get('/check-auth',
          {
            withCredentials: true,
          });
          console.log("Auth check response:", response.data);
        if (response.status === 200) {
          const username = response.data.username;
          const profile = response.data.profile
          setAuth(true, username, profile);
        } else {
          setAuth(false);
          console.log('Auth check failed', response.error);
        }
      } catch (error) {
        setAuth(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);


  return (
    <AuthContext.Provider value={{
      isAuthenticated, setIsAuthenticated: setAuth, isLoading, setIsLoading,
      username, userProfile, setTripIDState, TripIDState, reviseBillState, setReviseBillState,/* truckNumbersList, vendorsList, destinationList,*/ moduleChange, setModuleChange, activeModule, setActiveModule, searchValue, setSearchValue
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);;
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}